if (typeof Number.prototype.toPrice !== 'function') {
    // eslint-disable-next-line no-extend-native
    Number.prototype.toPrice = function(){
        return (this / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, " ").replace('.', ',').replace('-', '- ')
    }
}


// WEBPACK FOOTER //
// ./src/utils/NumberUtils.js